import { ColumnTable, Icon } from '@octano/global-ui';
import { useMemo } from 'react';

import useUserState from '../../../../hooks/useUserState';
import { PermissionName } from '../../../../types/Auth';

interface ActionsColumnsProps {
  onClickEdit: (row: any) => void;
  onClickDelete: (row: any) => void;
}

export default function useColumnActions({
  onClickEdit,
  onClickDelete,
}: ActionsColumnsProps): ColumnTable[] {
  const { isAuthorizedTo } = useUserState();

  const showActions = useMemo(() => {
    return !!isAuthorizedTo([PermissionName.SETTINGS]);
  }, [isAuthorizedTo]);

  return [
    {
      columnName: 'actions',
      headerText: '',
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ row }) => {
        return showActions ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ gap: 2 }}
          >
            <button
              type="button"
              className="btn btn-sm"
              onClick={() => onClickEdit(row)}
            >
              <Icon name="edit" />
            </button>
            <button
              type="button"
              className="btn btn-sm"
              onClick={() => onClickDelete(row)}
            >
              <Icon name="trash" />
            </button>
          </div>
        ) : (
          <></>
        );
      },
    },
  ];
}
